import {
  GetMarketplaceIntegrationsDocument,
  GetMarketplaceIntegrationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMarketplaceIntegrations = (
  variables: GetMarketplaceIntegrationsQueryVariables,
  skip = false
) => {
  const { loading, data } = useQuery(GetMarketplaceIntegrationsDocument, { variables, skip })

  return {
    loading,
    data: data?.marketplace.integrations || [],
  }
}
